import { useState, useRef } from "react";
import categories from "../../../api/skillCategories.json"
import styles from "./SkillsExpertise.module.scss";
import useInView from "../../../hooks/useInView";
import CategoryCard from "./children/categoryCard/CategoryCard";

const FILTERS = ["All", "Frontend", "Backend", "Mobile", "DevOps & Cloud"];

export default function SkillsExpertise() {
  const [activeFilter, setActiveFilter] = useState("All");
  const sectionRef = useRef(null);
  const animate = useInView(sectionRef, 0.06);

  const visible =
    activeFilter === "All"
      ? categories
      : categories.filter((c) => {
          const map = {
            Frontend: "Frontend Development",
            Backend: "Backend Development",
            Mobile: "Mobile Development",
            "DevOps & Cloud": "DevOps & Cloud",
          };
          return c.label === (map[activeFilter] || activeFilter);
        });

  return (
    <>
      <section className={styles["se-section"]} ref={sectionRef}>
        {/* header */}
        <div
          className={styles["se-header"]}
          style={{
            opacity: animate ? 1 : 0,
            transform: animate ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <h2>Skills & Expertise</h2>
          <div className={styles["se-underline"]} />
          <p>
            Comprehensive technical proficiency across the modern full stack
            development landscape.
          </p>
        </div>

        {/* filter tabs */}
        <div
          className={styles["se-filters"]}
          style={{
            opacity: animate ? 1 : 0,
            transition: "opacity 0.6s ease 0.2s",
          }}
        >
          {FILTERS.map((f) => {
            const matchCat = categories.find((c) => c.label.startsWith(f));
            return (
              <button
                key={f}
                className={`${styles["se-filter-btn"]}${activeFilter === f ? ` ${styles["active"]}` : ""}`}
                onClick={() => setActiveFilter(f)}
              >
                {matchCat && (
                  <span
                    className={styles["se-fi-dot"]}
                    style={{
                      background: activeFilter === f ? "#fff" : matchCat.color,
                    }}
                  />
                )}
                {f}
              </button>
            );
          })}
        </div>

        {/* category cards */}
        <div className={styles["se-grid"]}>
          {visible.map((cat, i) => (
            <CategoryCard
              key={cat.id}
              cat={cat}
              animate={animate}
              delay={i * 0.1}
            />
          ))}
        </div>
      </section>
    </>
  );
}
